export default __webpack_public_path__ + "static/media/hlthtek-qr.130cc10b.png";